import { Core } from "@faire/design-tokens";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";

import { ShimmerPlaceHolder } from "@faire/retailer/components/Animation/ShimmerPlaceHolder";

export const SuppliersPageHeaderLoadingSkeleton: React.FC = () => {
  return (
    <Column data-test-id="header-placeholder">
      <Row>
        <StyledPlaceHolder $width={120} $height={20} />
        <Spacer width="1x" />
        <Chevron direction="right" fontSize="14px" />
        <Spacer width="1x" />
        <StyledPlaceHolder $width={120} $height={20} />
      </Row>
      <Spacer height="1x" />
      <StyledPlaceHolder $height={36} $width={264} />
      <Spacer height={10} />
      <StyledPlaceHolder $height={36} $width={216} />
      <Spacer height="3x" />
      <StyledPlaceHolder $height={16} $width={288} />
      <Spacer height={10} />
      <StyledPlaceHolder $height={16} $width={232} />
      <Spacer height="4x" />
      <StyledPlaceHolder $height={16} $width={168} />
    </Column>
  );
};

const StyledPlaceHolder = styled(ShimmerPlaceHolder)`
  background-color: ${Core.surface.inverse};
`;
